import type { Transition, Variants } from 'motion/react';

export const ease = {
  standard: [0.2, 0.8, 0.2, 1] as const,
  emphasized: [0.16, 1, 0.3, 1] as const,
  exit: [0.4, 0, 1, 1] as const,
};

export const duration = { press: 0.09, fast: 0.16, base: 0.24, slow: 0.36 };

export const spring: Transition = { type: 'spring', stiffness: 380, damping: 32, mass: 0.9 };
export const softSpring: Transition = { type: 'spring', stiffness: 220, damping: 26 };

export const fadeRise: Variants = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: duration.base, ease: ease.emphasized } },
  exit: { opacity: 0, y: -4, transition: { duration: duration.fast, ease: ease.exit } },
};

/** Lists: 30 ms between items, capped so long lists never wait. */
export function stagger(index: number): Transition {
  return { delay: Math.min(index, 8) * 0.03, duration: duration.base, ease: ease.emphasized };
}

export const pageTransition: Variants = {
  hidden: { opacity: 0, y: 4 },
  show: { opacity: 1, y: 0, transition: { duration: 0.2, ease: ease.emphasized } },
  exit: { opacity: 0, transition: { duration: 0.12 } },
};
